import { CommonModule } from "@angular/common";
import { Component, computed, inject, signal } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { HorusMessageGeneralComponent } from "@shared/components/domain/horus-message-general/horus-message-general.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ServicesOrderState } from "@features/services/services-order.state";
import { ServiceDetailTabComponent } from "../service-detail-tab/service-detail-tab.component";
import { OrderServiceResponse } from "@features/order-detail/models/order-services.model";
import { OrderDetailService } from "@features/order-detail/services/order-detail.service";
import { HorusLoadingComponent } from "@shared/components/domain/horus-loading/horus-loading.component";
import { OdPaginationComponent } from "@shared/components/od-pagination.component";

@Component({
  selector: "app-services-panel",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatProgressSpinnerModule,
    HorusMessageGeneralComponent,
    ServiceDetailTabComponent,
    HorusMessageGeneralComponent,
    HorusLoadingComponent,
    OdPaginationComponent,
  ],
  templateUrl: "./services-panel.component.html",
  styleUrl: "./services-panel.component.scss",
})
export class ServicesPanelComponent {
  searchDataForm: FormGroup;
  readonly columns = ["os", "fechaRegistro", "fechaEstimada", "acciones"];
  orderDetailService = inject(OrderDetailService);

  readonly currentPage = signal(1);
  readonly itemsPerPage = 3;

  readonly paginatedData = computed(() => {
    const data = this.serviceOrderService.parsedData() || [];
    const start = (this.currentPage() - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    return data.slice(start, end);
  });

  constructor(
    private fb: FormBuilder,
    readonly serviceOrderService: ServicesOrderState,
  ) {
    this.searchDataForm = this.fb.group({
      searchValue: [""],
    });
  }

  readonly totalItems = computed(() => {
    return this.serviceOrderService.parsedData()?.length || 0;
  });

  searchClientData() {
    if (this.searchDataForm.invalid) {
      return;
    }
    const searchValue = this.searchDataForm.get("searchValue")?.value?.trim();
    if (!searchValue) return;
    this.currentPage.set(1);
    this.serviceOrderService.setManualSearchValue(searchValue);
  }

  onPageChange(page: number) {
    this.currentPage.set(page);
  }

  onServiceRowClick(service: OrderServiceResponse) {
    const data = this.serviceOrderService.parsedData();
    if (!data) return;

    const index = data.findIndex(s => s.osId === service.osId);
    if (index !== -1) {
      this.serviceOrderService.setSelectedIndex(index);
    }
  }

  clearFilters() {
    this.searchDataForm.reset();
    this.currentPage.set(1);
  }
}
